import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Alert } from 'react-bootstrap';
import ShopHOC from '../../../../hoc/ShopHOC';
import OrderCard from '../OrderCard/OrderCard';
import LoadingOverlay from '../../../common/LoadingOverlay';
import api from '../../../../api/index';
import { fetchCart } from '../../../../actions';

function OrderSummary({ orderRowsMeta, eventID, partnerPortalSettings }) {
    const { t } = useTranslation();
    const { orderID } = useParams();
    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState({});
    const [error, setError] = useState(null);
    const [orderMeta, setOrderMeta] = useState({});
    const dispatch = useDispatch();
    const { userCanEditOrders } = partnerPortalSettings;

    useEffect(() => {
        const showError = () => {
            setError(true);
            setLoading(false);
        };
        
        api.shop.getOrder(orderID)
            .then((response) => {
                const { order } = response.data.data;
                if (order) {
                    setOrder(order);

                    api.shop.getOrdersMeta()
                        .then((response) => {
                            setOrderMeta(response.data.data.meta)
                            setLoading(false);
                        })
                        .catch(showError);
                } else {
                    showError();
                }
            })
            .catch(showError);
        
        return () => {
            if (userCanEditOrders) {
                dispatch(fetchCart(eventID));
            }
        }
    }, [dispatch, eventID, orderID, userCanEditOrders]);

    return (
        <Row>
            <Col md={12}>
               {(!loading && !error) ?
                    <Alert variant="success">
                        <strong>{t('orders.order_success_text')}</strong>
                    </Alert>
                : null}
                <Card>
                    <Card.Header>
                        {t('orders.order_summary')}
                    </Card.Header>
                    <Card.Body style={{ position: 'relative' }}>
                        {(!loading && !error) ?
                            <>
                                <OrderCard
                                    order={order}
                                    orderMeta={orderMeta}
                                    orderRowsMeta={orderRowsMeta}
                                />
                            </>
                        : null}

                        {(!loading && error) ?
                            <Alert variant="danger">
                                {t('orders.order_failure_message')}
                            </Alert>
                        : null}

                        {loading ?
                            <LoadingOverlay />    
                        : null}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}

export default ShopHOC(OrderSummary);
